const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getLogoUrl = (teamId) => `${API}/teams/${teamId}/logo-image`;

const calcPct = (shotStr) => {
  if (!shotStr || shotStr === '0/0') return null;
  const parts = shotStr.split('/');
  if (parts.length !== 2) return null;
  const made = parseInt(parts[0], 10);
  const attempted = parseInt(parts[1], 10);
  if (isNaN(made) || isNaN(attempted) || attempted === 0) return null;
  return Math.round((made / attempted) * 100);
};

const formatShot = (shotStr) => {
  const pct = calcPct(shotStr);
  if (pct === null) return shotStr || '0/0';
  return `${shotStr} (${pct}%)`;
};

const GOOGLE_FORMS = {
  playerRegistration: 'https://forms.gle/xoHRnvDpzzQpXaHJ9',
  teamRegistration: 'https://forms.gle/X3hnQFuzm48Ezw966',
};

export { BACKEND_URL, API, getLogoUrl, calcPct, formatShot, GOOGLE_FORMS };
